/**
 * @author yan st
 * @date 2023-11-13 09:50
 * @Description:
 */

/**
 * 获取Token
 */
export const getToken = () => {
  let user = JSON.parse(window.localStorage.getItem('user'))
  return user ? {token: user.token} : '';
}
/**
 * 获取Token
 */
export const getUser = () => {
  let user = JSON.parse(window.localStorage.getItem('user'))
  return user
}

export const nav = [
  {
    name:`合同准合同<br>纠纷`,
    active:0,
    url:'/home/index',
    icon:'iconfont icona-hetong3',
    show:false,
    list:[],
    names:'合同准合同纠纷'
  },
  {
    name:`劳动争议<br>人事争议`,
    active: 1,
    url:'/home/indexa',
    icon:'iconfont iconlaba2',
    show:false,
    list:[],
    names:'劳动争议人事争议'
  },
  {
    name:`知识产权与<br>竞争纠纷`,
    active: 2,
    url:'/home/indexb',
    icon:'iconfont iconzhishichanquan',
    show:false,
    list:[],
    names:'知识产权与竞争纠纷'
    // list:[
    //   {
    //     title:'机构信息',
    //     url:'/home/information',
    //     act: 0
    //   },
    //   {
    //     title:'密码修改',
    //     url:'/home/pass',
    //     act: 1
    //   }
    // ]
  },
  // {
  //   name:`学会自查清单`,
  //   active:3,
  //   url:'/home/index',
  //   icon:'iconfont iconzichaguanli-01',
  //   show:false,
  //   list:[],
  //   names:'学会自查清单'
  // },
  // {
  //   name:`学会关注要点`,
  //   active:4,
  //   url:'/home/index',
  //   icon:'iconfont iconguanzhu06',
  //   show:false,
  //   list:[],
  //   names:'学会关注要点'
  // },
  // {
  //   name:'展示页面',
  //   active: 3,
  //   url:'/home/exhibition',
  //   icon:'iconfont icon-diannao',
  //   show:false,
  //   list:[]
  // },
]



/*
* 时间转换
* */
export const zhDate = (date, type) => {
  let now = new Date(date)
  let year = now.getFullYear()
  let month = now.getMonth() + 1
  let day = now.getDate()
  let hour = now.getHours()
  let minute = now.getMinutes()
  let second = now.getSeconds()
  if (type === 1) {
    return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute)
  } else if (type === 2) {
    return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
  } else if (type === 3) {
    return getzf(hour) + ":" + getzf(minute)
  } else if (type === 4) {
    return year
  } else if(type === 5) {
    return year + "-" + getzf(month)
  } else {
    return year + "-" + getzf(month) + "-" + getzf(day)
  }
}

function getzf(num) {
  if (parseInt(num) < 10) {
    num = '0' + num
  }
  return num
}

export const zhRmb = (num) => {
  if (Number(num) > 10000) {
    return (Number(num) / 10000).toFixed(2) + '万元'
  } else {
    return num + '元'
  }
}

export const getUrlBase64=(url)=> {
  return new Promise(resolve => {
    let canvas = document.createElement('canvas')
    let ctx = canvas.getContext('2d')
    let img = new Image()
    img.crossOrigin = 'anonymous' //允许跨域
    img.src = url
    img.onload = function() {
      canvas.height = 300
      canvas.width = 300
      ctx.drawImage(img, 0, 0, 300, 300)
      let dataURL = canvas.toDataURL('image/png')
      canvas = null
      resolve(dataURL)
    }
  })
}

/*
*
* */
export const getYearAndMonth = (start, end) => {
  var result = [];
  var starts = start.split('-');
  var ends = end.split('-');
  var staYear = parseInt(starts[0]);
  var staMon = parseInt(starts[1]);
  var endYear = parseInt(ends[0]);
  var endMon = parseInt(ends[1]);
  while (staYear <= endYear) {
    if (staYear === endYear) {
      while (staMon < endMon) {
        staMon++;
        var str = staYear + '-'+(staMon >= 10 ? staMon : '0' + staMon);
        result.push(str);
      }
      staYear++;
    } else {
      staMon++;
      if (staMon > 12) {
        staMon = 1;
        staYear++;
      }
      let str = staYear + '-'+(staMon >= 10 ? staMon : '0' + staMon);
      result.push(str);
    }
  }
  // console.log(result)
  return result;



}

//  element时间插件 时间 转换为 yyyy-mm-ss
export const resDate = (date) => {
  const d = new Date(date)
  let time = d.getFullYear() + '-' + p((d.getMonth() + 1)) + '-' + p(d.getDate())
  return time

}
const p = (s) => {
  return s < 10 ? '0' + s : s
}
